
<template>
  <div>
    <div class="find">
      <div class="seach-top">
        <el-form
          ref="searchForm"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >
          <el-form-item
            label="关键字："
          >
            <el-input
              v-model="searchForm.keyWord"
              placeholder="请输入查询关键字"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="handleSearch"
            >
              查询
            </el-button>
          </el-form-item>
          <div class="btn-box" style="float: right;">
            <el-form-item>
              <el-button
                style="margin-left: 8px"
                size="small"
                type="primary"
                @click="handleExport()"
              >
                导出
                <i class="el-icon-download el-icon--right" />
              </el-button>
              <el-button
                type="primary"
                class="btnBack"
                size="small"
                @click="()=>{this.$router.go(-1)}"
              >
                &lt;&lt;返回
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>

    <el-table
      class="table-list"
      :border="true"
      :data="tableData"
      style="width: 100%"
      @sort-change="handleResort"
    >
      <!-- 序号 -->
      <el-table-column label="序号" type="index" width="50px" align="right" />

      <el-table-column prop="noteDay" label="日期" width="100px" align="center" sortable="custom">
        <template slot-scope="scope">
          {{ scope.row.noteDay|dateFmt }}
        </template>
      </el-table-column>

      <el-table-column label="类别" prop="fenLeiDictKeyItemName" width="100px" />
      <el-table-column label="标签" prop="tags" :show-overflow-tooltip="true" width="200px">
        <template slot-scope="scope">
          <el-tag v-for="(i,idx) in getTagList(scope.row.tags)" :key="idx">{{ i }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="标题" prop="title" width="200px" />
      <el-table-column label="内容" prop="content" min-width="350px" :show-overflow-tooltip="true" />

      <el-table-column
        fixed="right"
        label="操作"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            v-if="!scope.row.isEdit"
            type="text"
            size="mini"
            plain
            @click.stop="handleEdit( scope.row,scope.$index)"
          >
            修改
          </el-button>

          <el-button
            v-if="!scope.row.isEdit"
            type="text"
            size="mini"
            @click.stop="handleDel(scope.row)"
          >
            删除

          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next,total,sizes"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      :total="totalCount"
      @size-change="handleSizeChange"
      @current-change="handleChangePage"
    />
    <NoteEdit
      v-model="editFormShow"
      :entity-id="entityId"
      @save-success="handleSearch"
    />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
import NoteEdit from './headerCalendarNoteEdit'
export default {
  components: {
    NoteEdit
  },
  filters: {
    dateFmt(val) {
      return KxjCom.tableDateFormat(val)
    },
    decFmt(val) {
      return KxjCom.tableDecFormat(val)
    }
  },
  data() {
    return {
      moduleCode: 'xz02',
      tableHeader: [],
      totalCount: 0,
      tableData: [],
      allComboxData: [],
      searchForm: {
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: '',
        keyWord: ''
      },
      uploadData: [],
      uploadFormShow: false,
      // 认领项目数
      otherProjectCount: 0,
      renLingShow: false,
      editFormShow: false,
      entityId: null
    }
  },
  // 画面激活
  activated() {
    this.handleSearch()
  },
  // 初期化数据
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D33;D34').then(res => {
      this.allComboxData = res.data.result
    })
  },
  mounted() {},
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    // 每页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.handleSearch()
    },
    // 切页
    handleChangePage(page) {
      this.searchForm.pageNumber = page
      this.handleSearch()
    },
    // 排序
    handleResort(column) {
      this.searchForm.sortKey = column.prop
      this.searchForm.sortOrder = column.order
      this.handleSearch()
    },
    // 新增
    handleAdd() {

    },
    // 查询
    handleSearch() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      var path = '/api/services/app/note/GetPagedListnotes'
      pathReq
        .getList(path, that.searchForm)
        .then(res => {
          loading.close()
          that.totalCount = res.data.result.totalCount
          that.tableData = res.data.result.items
        })
    },
    // 编辑
    handleEdit(row) {
      this.entityId = row.id
      this.editFormShow = true
    },

    // 删除
    handleDel(row) {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      this.$confirm('确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(KxjCom.loadOptions)
        const path = '/api/services/app/note/Deletenote'
        pathReq.dataDelete(path, row.id).then(res => {
          this.$message.success('删除成功!')
          loading.close()
        }).then(_ => {
          that.handleSearch()
        })
      }).catch(() => {
        loading.close()
      })
    },

    // 导出
    handleExport() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          '项目名称',
          '类型',
          '角色',
          '开始日期',
          '结束日期',
          '详情'
        ]
        const filterVal = [
          'xiangMuMingCheng',
          'leiXingDictKeyItemName',
          'jueSeDictKeyItemName',
          'kaiShiRiQiShow',
          'jieSuRiQiShow',
          'xiangQing'
        ]
        const list = this._data.tableData
        const data = KxjCom.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '事务管理', // 非必填
          autoWidth: true, // 非必填
          bookType: 'xlsx' // 非必填
        })
        this.downloadLoading = false
      })
    },
    getTagList(tag) {
      if (tag) {
        return tag.split(',')
      } else {
        return []
      }
    }

  }
}
</script>

<style scoped>
/* ffc059 */
</style>
